"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_IMAGE_TYPE = exports.LARGEST_IMAGE_SIZE = exports.DEFAULT_IMAGE_SIZE = exports.ALLOWED_SIZES_V2 = exports.ALLOWED_SIZES = void 0;
// These are the valid image widths supported by our image service.
// When requesting a cropped image, ensure that it's a valid width.
exports.ALLOWED_SIZES = [
    75,
    120,
    150,
    240,
    375,
    500,
    750,
    1000,
    1250,
    1500,
    1800,
    2200,
    2600,
    3000,
    3500
];
// valid image widths supported by go-image-v2
exports.ALLOWED_SIZES_V2 = [
    50,
    75,
    100,
    120,
    150,
    200,
    240,
    300,
    360,
    375,
    400,
    500,
    600,
    700,
    750,
    800,
    850,
    900,
    950,
    1000,
    1250,
    1500,
    1600,
    1800,
    2000,
    2200,
    2400,
    2600,
    3000,
    3200,
    3500,
    3700,
    4000
];
exports.DEFAULT_IMAGE_SIZE = 750;
exports.LARGEST_IMAGE_SIZE = 3500;
exports.ALLOWED_IMAGE_TYPE = ["jpeg", "png", "webp"];
//# sourceMappingURL=imageConstants.js.map